<template>
    <b-container>
        <b-row>
            <b-col cols=12>
                <img :src="logo" alt="PinPoint Logo">

                <!-- ********************************* -->
                <!-- **** Card holds Patient Tree **** -->
                <!-- ********************************* -->
                <div class="pt-5">
                  <b-card
                    header-bg-variant="Info"
                    :header="cardTitle"
                    border-variant="dark"
                    header-border-variant="secondary"
                  >
                    <!-- ************************************************** -->
                    <!-- **** Bind patientData To node prop            **** -->
                    <!-- **** and  bind parent_id to parent_id prop    **** -->
                    <!-- **** to be used in DisplayAttributes.vue     **** -->
                    <!-- ************************************************** -->
                    <DisplayAttributes v-if="parent_id"
                      :node="patientData"
                      :parent_id = "parent_id"
                    />
                  </b-card>
                </div>

            </b-col>
          </b-row>
    </b-container>
 </template>


<script>

import PinPointLogo from "../../../assets/PinPointLogo.png"
import DisplayAttributes from './DisplayAttributes'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  components: {
    DisplayAttributes
  },
  data: function () {
    return {
        logo: PinPointLogo,
        cardTitle: 'Patient Records',
        theData: {},
    }
  },
  beforeMount() {
    // Check Route Name
    if(this.$route.name === 'DisplayIndex') {
      this.$store.dispatch('loadPatientData', this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters({
      patientData: 'getPatientData',
      parent_id: 'getParentId',
    }),
    setData() {
      this.theData = this.patientData;
      return this.theData
    }
  },
}
</script>
